import RegionDash from './RegionDashboard';

export const RegionDashboard = RegionDash;
